let fsSlider = document.querySelector('.fs-slider')

if(fsSlider) {
    let tabs = document.querySelectorAll('.fs-tabs .tab')
    let images = document.querySelectorAll('.first-slide .images .image')
    
    let slider = new Swiper(fsSlider, {
        slideClass: 'slide',
        autoHeight: true,
        speed: 600,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.fs-dots'
        },
        navigation: {
            nextEl: '.fs-next',
            prevEl: '.fs-prev',
        },
        on: {
            slideChange: () => {
                let index = slider.activeIndex

                for(let tab of tabs) {
                    tab.classList.remove('active')
                }

                for(let image of images) {
                    image.classList.remove('active')
                }

                tabs[index].classList.add('active')
                images[index].classList.add('active')
            }
        }
    })

    for(let tab of tabs) {
        tab.addEventListener('click', () => {
            let index = tab.index()

            slider.slideTo(index)
        })
    }
}